"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

require("./style.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Hamburger = function Hamburger(_ref) {
  var onClick = _ref.onClick,
      numberOfLines = _ref.numberOfLines;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "Hamburger",
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "title"
  }, "Menu"), /*#__PURE__*/_react.default.createElement("div", {
    className: "hamburger-menu"
  }, Array.from({
    length: numberOfLines
  }).map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("span", {
      key: index
    });
  })));
};

Hamburger.defaultProps = {
  onClick: function onClick() {},
  numberOfLines: 3
};
var _default = Hamburger;
exports.default = _default;